import { Flex, Spinner } from "@chakra-ui/react";

export default function Loading({ isLoading }) {
  return (
    <>
      {isLoading && (
        <Flex
          position="fixed"
          top="0"
          bottom="0"
          left="0"
          right="0"
          justifyContent="center"
          alignItems="center"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          zIndex="9999"
        >
          <Spinner size="xl" color="white" />
        </Flex>
      )}
    </>
  );
}
